import { Inbox } from "lucide-react";

export const EmptyState = ({ icon: Icon = Inbox, title = "Aucune donnée", description, action }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-[#E2E8F0] bg-white/60 px-6 py-16 text-center" data-testid="empty-state">
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#EEF2F8] text-[#001A3B]">
      <Icon className="h-7 w-7" />
    </div>
    <p className="font-heading text-base font-semibold text-[#18221F]">{title}</p>
    {description && <p className="mt-1 max-w-sm text-sm text-[#4A5568]">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
